export const VALIDATION_PATTERNS = {
	GENERIC:{
		ALPHANUMERIC_PATTERN: '^[a-zA-Z0-9_\\-.:]+$'
	},
	PERMISSIONS: {
		RELEASE_BUNDLE: {
			BUNDLE_NAME_PATTERN: '^([\\*?])+([\\w\\d\\-\\:\\.\\?\\*])*$|^([a-zA-Z\\d]){1}([\\w\\d\\-\\:\\.\\?\\*])*([\\*?])+([\\w\\d\\-\\:\\.\\?\\*])*$'
		},
	},
	CREATE_BUNDLE: {
		BUNDLE_NAME: '^[a-zA-Z0-9]+[a-zA-Z0-9_\\-.:]*$',
		BUNDLE_VERSION: '^[a-zA-Z0-9]+[a-zA-Z0-9_\\-.:]*$'
	},
};


// WEBPACK FOOTER //
// ./modules/distribution/constants/validation.patterns.constants.js